import React, { MouseEventHandler } from 'react'
import { OpenModalConsumerProps } from 'types/common'
import Modal from 'ui-shared/Modal'

type Props = OpenModalConsumerProps & {
  handleSubmit: MouseEventHandler<HTMLButtonElement>
}

const EventCreateConfirmationModal: React.FC<Props> = ({
  closeModal,
  isOpen,
  handleSubmit,
}) => {
  const handleConfirm: MouseEventHandler<HTMLButtonElement> = (e) => {
    handleSubmit(e)
    closeModal()
  }

  return (
    <Modal
      title=""
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onClose={() => closeModal()}
    >
      <h2>ATTENTION PLEASE</h2>
      <div>
        <p>
          "You are about to create an event in PRODUCTION ENVIRONMENT and
          trigger a confirmation EMAIL. Do you want to continue?"
        </p>
      </div>
    </Modal>
  )
}

export default EventCreateConfirmationModal
